// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
export type ReadyPlanConfigCard_ReadyPlanConfigLike_CheckoutConfig_Fragment = { __typename?: 'CheckoutConfig', id: string, name?: string | null | undefined, updatedAt: Types.Scalars['DateTime']['input'], aduProgramData?: { __typename?: 'ProgramData', id: string, sellableSqft?: number | null | undefined, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined, widthInFeet?: number | null | undefined, depthInFeet?: number | null | undefined } | null | undefined, programData?: { __typename?: 'ProgramData', id: string, sellableSqft?: number | null | undefined, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined, widthInFeet?: number | null | undefined, depthInFeet?: number | null | undefined } | null | undefined };

export type ReadyPlanConfigCard_ReadyPlanConfigLike_ProductOfferingConfig_Fragment = { __typename?: 'ProductOfferingConfig', id: string, name: string, updatedAt: Types.Scalars['DateTime']['input'], programData: { __typename?: 'ProgramData', id: string, sellableSqft?: number | null | undefined, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined, widthInFeet?: number | null | undefined, depthInFeet?: number | null | undefined } };

export type ReadyPlanConfigCard_ReadyPlanConfigLike_ProjectReadyPlanConfig_Fragment = { __typename?: 'ProjectReadyPlanConfig', id: string, name?: string | null | undefined, updatedAt: Types.Scalars['DateTime']['input'], programData?: { __typename?: 'ProgramData', id: string, sellableSqft?: number | null | undefined, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined, widthInFeet?: number | null | undefined, depthInFeet?: number | null | undefined } | null | undefined };

export type ReadyPlanConfigCard_ReadyPlanConfigLikeFragment =
  | ReadyPlanConfigCard_ReadyPlanConfigLike_CheckoutConfig_Fragment
  | ReadyPlanConfigCard_ReadyPlanConfigLike_ProductOfferingConfig_Fragment
  | ReadyPlanConfigCard_ReadyPlanConfigLike_ProjectReadyPlanConfig_Fragment
;

export type ReadyPlanConfigCard_StructureFragment = { __typename?: 'Structure', id: string, isAdu: boolean };

export type ReadyPlanConfigCard_ReadyPlanOptionFragment = { __typename?: 'ReadyPlanOption', id: string, maybeShortName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, order: number, forDesignPackages: boolean } };

export type ReadyPlanConfigCard_ProgramDataFragment = { __typename?: 'ProgramData', id: string, sellableSqft?: number | null | undefined, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined, widthInFeet?: number | null | undefined, depthInFeet?: number | null | undefined };

export const ReadyPlanConfigCard_ProgramDataFragmentDoc = gql`
    fragment ReadyPlanConfigCard_ProgramData on ProgramData {
  id
  sellableSqft
  bedrooms
  fullBaths
  halfBaths
  widthInFeet
  depthInFeet
}
    `;
export const ReadyPlanConfigCard_ReadyPlanConfigLikeFragmentDoc = gql`
    fragment ReadyPlanConfigCard_ReadyPlanConfigLike on ReadyPlanConfigLike {
  id
  name
  updatedAt
  programData {
    ...ReadyPlanConfigCard_ProgramData
  }
  ... on CheckoutConfig {
    id
    aduProgramData {
      ...ReadyPlanConfigCard_ProgramData
    }
  }
}
    ${ReadyPlanConfigCard_ProgramDataFragmentDoc}`;
export const ReadyPlanConfigCard_StructureFragmentDoc = gql`
    fragment ReadyPlanConfigCard_Structure on Structure {
  id
  isAdu
}
    `;
export const ReadyPlanConfigCard_ReadyPlanOptionFragmentDoc = gql`
    fragment ReadyPlanConfigCard_ReadyPlanOption on ReadyPlanOption {
  id
  maybeShortName
  optionGroup {
    id
    name
    order
    forDesignPackages
  }
}
    `;